import { render } from "./EmailCommunication.vue?vue&type=template&id=436fd220&scoped=true"
import script from "./EmailCommunication.vue?vue&type=script&lang=js"
export * from "./EmailCommunication.vue?vue&type=script&lang=js"

import "./EmailCommunication.vue?vue&type=style&index=0&id=436fd220&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436fd220"]])

export default __exports__